import script from "./MediaLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaLibrary.vue?vue&type=script&setup=true&lang=js"

import "./MediaLibrary.vue?vue&type=style&index=0&id=48408a6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48408a6e"]])

export default __exports__